import { Menu, Visibility } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  SxProps,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../Redux/hooks";

import { useState } from "react";

import { headerStyle } from "./block.style";
import RearrangeModal from "./RearrangeModal";
import UploadIcon from "@mui/icons-material/Upload";
import ImportConsentBlocksModal from "./ImportConsentBlockModal";
import BackButton from "../../Common/UI/BackButton";

const LoaderStyle: SxProps = {
  mr: "50px",
};

const CBHeader = () => {
  const navigate = useNavigate();
  const editable = useAppSelector((state) => state.consent.editable);
  const loading = useAppSelector((state) => state.consent.loading);
  const formSubmitting = useAppSelector(
    (state) => state.consent.formSubmitting
  );
  const consentName = useAppSelector((state) => state.consent.consentName);
  const versionId = useAppSelector((state) => state.consent.versionId);
  const length = useAppSelector((state) => state.consent.blocks.length);
  const formType = useAppSelector((state) => state.consent.formType);

  const [showModal, setShowModal] = useState("");
  const [showImportModal, setShowImportModal] = useState(false);

  const handleBack = () => {
    navigate(-1);
  };

  const handlePreview = () => {
    navigate(`../preview?versionId=${versionId}&formType=${formType}`, {
      relative: "path",
    });
  };

  const openModal = (name: string) => {
    setShowModal(name);
  };

  const closeModal = () => {
    setShowModal("");
  };

  const closeImportModal = () => {
    setShowImportModal(false);
  };

  return (
    <Box sx={headerStyle}>
      <BackButton onClick={handleBack} sx={{ mr: 1 }} />

      <Typography
        variant="h2"
        color="text.primary"
        sx={{
          flex: 1,
          minWidth: "0px",
        }}
        noWrap
      >
        {consentName || "Form Builder"}
      </Typography>

      <span style={{ marginLeft: "auto" }} />

      {!loading ? (
        formSubmitting ? (
          <CircularProgress size={25} sx={LoaderStyle} />
        ) : (
          <>
            <Button
              onClick={handlePreview}
              variant="outlined"
              sx={{ mr: 2 }}
              startIcon={<Visibility />}
            >
              Preview
            </Button>

            {editable && (
              <Button
                variant="contained"
                component="label"
                startIcon={<UploadIcon />}
                sx={{ mr: 2 }}
                onClick={() => setShowImportModal(true)}
              >
                Import Blocks
              </Button>
            )}

            {editable && length >= 2 && (
              <Button
                variant="outlined"
                startIcon={<Menu />}
                onClick={() => openModal("rearrangeQuestions")}
                sx={{ mr: 2 }}
              >
                Rearrange
              </Button>
            )}

            {showModal === "rearrangeQuestions" && (
              <RearrangeModal closeModal={closeModal} />
            )}
          </>
        )
      ) : null}
      {showImportModal && (
        <ImportConsentBlocksModal
          showModal={showImportModal}
          closeModal={closeImportModal}
        />
      )}
    </Box>
  );
};

export default CBHeader;
